import { CataleanModelsModule } from 'catalean-models';
import { environment } from 'src/environments/environment';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { CataleanProviderModule } from 'catalean-provider';
import { CataleanHamburgerMenuModule } from 'catalean-hamburger-menu';
import { CataleanLocalFilesModule } from 'catalean-local-files';
import { SharedModule } from './shared.module';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CataleanLocalizationModule } from 'catalean-localization';
import { CataleanStorageModule } from 'catalean-storage';
import { CataleanVersionControllerModule } from 'catalean-version-controller';
import {AuthConfig, OAuthModule, OAuthModuleConfig, OAuthStorage} from "angular-oauth2-oidc";
import {authConfig, authModuleConfig} from "../config/auth.config";
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { CataleanAuthenticationService } from 'catalean-authentication';
import { LottieModule } from 'ngx-lottie';

const env = environment;
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
export function storageFactory(): OAuthStorage {
  return localStorage;
}

export const authServiceInit = (authService:CataleanAuthenticationService) => {
  // init operazioni preliminari
  return () => authService.runInitialLoginSequence();
}

// Note we need a separate function as it's required
// by the AOT compiler.
export function playerFactory() {
	return import(/* webpackChunkName: 'lottie-web' */ 'lottie-web');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    OAuthModule.forRoot(),
    IonicModule.forRoot(),
    AppRoutingModule,
    CataleanProviderModule.forRoot(env),
    CataleanModelsModule,
    CataleanHamburgerMenuModule,
    CataleanLocalFilesModule.forRoot(env.resourceBatchLimit, false),
    CataleanVersionControllerModule.forRoot(environment.catalean),
    CataleanHamburgerMenuModule.forRoot(environment.version),
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    CataleanStorageModule,
    CataleanLocalizationModule,
    NoopAnimationsModule,
    LottieModule.forRoot({ player: playerFactory }),
  ],
  providers: [
    { provide: AuthConfig, useValue: authConfig },
    { provide: OAuthModuleConfig, useValue: authModuleConfig },
    { provide: OAuthStorage, useFactory: storageFactory },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: APP_INITIALIZER, useFactory:authServiceInit, deps:[CataleanAuthenticationService], multi: true }, 
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ScreenOrientation,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
